import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';

import { MarketLinkIcon } from 'components/icons';
import { Table } from 'components/MRT';
import { NextLink } from 'components';

import { AssetsTableData } from '../../types';
import { columns } from './tableColumns';

export function AssetsTable({
  shouldRenderActionsColumn,
  data,
}: {
  shouldRenderActionsColumn: boolean;
  data: AssetsTableData[];
}) {
  const pageSize = 10;
  const enablePagination = data.length > pageSize;

  return (
    <Table<AssetsTableData>
      initialState={{
        density: 'compact',
        columnVisibility: { lowSupply: false },
        pagination: { pageIndex: 0, pageSize },
      }}
      state={{
        columnOrder: [
          'rating',
          'asset',
          shouldRenderActionsColumn ? 'mrt-row-actions' : null,
          'price',
          'totalCollateral',
          'collateral24',
          'totalBorrow',
          'borrows24',
          'lowSupply',
        ].filter((value): value is string => !!value),
      }}
      autoPinningColumns={[
        'rating',
        'asset',
        shouldRenderActionsColumn ? 'mrt-row-actions' : null,
      ].filter((value): value is string => !!value)}
      data={data}
      columns={columns}
      enableColumnFilterModes
      enableRowActions={shouldRenderActionsColumn}
      enablePagination={enablePagination}
      withFullScreenButton
      enablePinning={false}
      enableTopToolbar={false}
      renderRowActions={({ row }) =>
        row.original.marketHref && (
          <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'nowrap', gap: '8px' }}>
            <NextLink href={row.original.marketHref}>
              <Tooltip title="View Market analytics">
                <IconButton sx={{ fontSize: '0.85rem' }}>
                  <MarketLinkIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
            </NextLink>
          </Box>
        )
      }
    />
  );
}
